import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router'
import { Button } from '@mui/material'
import _ from 'lodash'

import { TO_PARENT_PATH } from '@/modules/urlRouting/paths'

import { usePolicyEditContext } from '../../policyEditController'
import { getModalText } from '../../utils/modalText'

import { PRIMARY_BUTTON_SX, TEXT_BUTTON_SX } from './styles'

/**
 * Cancel and Save when the user edits, creates or duplicates a policy. They do the same as the
 * old `EditHeader`.
 */
export const ThemedEditActions: FC = () => {
  const { t } = useTranslation()
  const controller = usePolicyEditContext()
  const { policy } = controller

  if (!policy) return null

  const save = async () => {
    const saved = await controller.save()
    if (saved && _.includes(policy.parkingFeeType, 'variable'))
      controller.setModalProps({ ...getModalText().INFO_DATA_PROCESSING })
  }

  return (
    <>
      <Button
        component={RouterLink}
        to={TO_PARENT_PATH}
        state={{ policyJson: controller.originalPolicy?.toJson }}
        sx={TEXT_BUTTON_SX}
      >
        {t('common.cancelTitle', 'Cancel')}
      </Button>
      <Button onClick={save} variant="contained" sx={PRIMARY_BUTTON_SX}>
        {t('common.saveTitle', 'Save')}
      </Button>
    </>
  )
}
